<template>
  <div class="order-detail">
    <div class="info-wrap" v-if="tracks && tracks.length">
      <h2 class="title">
        推荐进展<span v-if="id" class="candidate-id">#{{id}}</span>
        <template v-if="candidate">
          <span v-if="candidate.candidateTracks && candidate.candidateTracks.length && candidate.candidateTracks[0].progressType && candidate.candidateTracks[0].progressType == 57" class="tips-status status-nopass">自动打回</span>
          <span v-else class="tips-status" :class="[2,3,8,9,12,13,14,16,20,21,24].includes(candidate.allStatus) ? 'status-nopass' : 'status-pass'">{{candidate.allStatus | allCandidateStatus}}</span>
        </template>
      </h2>
      <order-progress :tracks="tracks"></order-progress>
    </div>
    <div class="info-wrap">
      <h2 @click="goReport" class="title no-border">推荐报告<van-icon class="icon-arrow" name="arrow" /></h2>
    </div>
    <div class="info-wrap">
      <h2 class="title">推荐职位</h2>
      <div class="position-list-wrap">
        <position-item :position="positionDetail"></position-item>
      </div>
    </div>
    <div class="info-wrap">
      <h2 class="title">候选人</h2>
      <div class="position-list-wrap">
        <talent-item :candidate="candidate" :talent-tags="talentTags"></talent-item>
      </div>
    </div>
    <div class="info-wrap">
      <h2 class="title">AI复推</h2>
      <div class="position-list-wrap">
        <tab-nearby></tab-nearby>
      </div>
    </div>
    <div class="btn-wrap">
      <van-button type="default" v-if="candidate" @click="showTalent = true" class="btn-def">联系候选人</van-button>
      <van-button type="primary" v-if="osViews" @click="showOS = true" class="btn-pri">订单咨询</van-button>
    </div>
    <!--联系候选人弹出层-->
    <van-popup v-model="showTalent" position="bottom" class="pop-up-talent">
      <pop-talent @close="showTalent=false" :talent="candidate"></pop-talent>
    </van-popup>
    <!--订单咨询弹出层-->
    <van-popup v-model="showOS" position="bottom" class="pop-up-talent">
      <pop-oS @close="showOS=false" :os="osViews"></pop-oS>
    </van-popup>
  </div>
</template>
<style scoped lang="scss">
  .order-detail{
    width: 100%;
    background-color: #f5f5f5;
    padding-bottom: 74px;
  }
  .info-wrap{
    margin-bottom: 10px;
    background: #fff;
    h2.title{
      font-size: 16px;
      color: #333;
      border-bottom: solid .5px #e5e5e5;
      margin: 0 0 0 15px;
      padding-right: 15px;
      height: 50px;
      line-height: 50px;
      position: relative;
      .candidate-id{
        color: #666;
        font-size: 12px;
        margin-left: 10px;
      }
      .icon-arrow{
        position: absolute;
        right: 15px;
        top: 15px;
      }
      .tips-status{
        border-radius: 2px;
        padding: 0 4px;
        height: 17px;
        line-height: 15px;
        font-size: 10px;
        float: right;
        margin: 17px 0 0 0;
      }
      .status-nopass{
        color: #FF6E00;
        border: .5px solid #FF6E00;
      }
      .status-pass{
        color: #22BAA5;
        border: .5px solid #22BAA5;
      }
    }
    h2.no-border{
      border: 0;
    }
    .position-list-wrap{
      width: 100%;
      background-color: #f5f5f5;
    }
  }
  .btn-wrap{
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 0;
    background-color: #FAFAFA;
    justify-content: space-around;
    .btn-def,.btn-pri{
      font-size: 16px;
      border-radius: 4px;
      flex-grow: 1
    }
    .btn-def{
      margin: 0 10px 0 15px;
      border-color: #22BAA5;
      color: #22BAA5;
    }
    .btn-pri{
      margin: 0 15px 0 0;
    }
  }
</style>
<script>
import orderProgress from "@/components/order/progress";
import positionItem from '@/components/order/positionItem'
import TabNearby from "@/components/position/tabNearby";
import talentItem from '@/components/order/talentItem'
import popTalent from "@/components/popTalent";
import popOS from "@/components/popOS";
import { getCandidateDetail, getOsUser, getTalentTag} from '@/api/order';
import {getPositionDetail, getPositionTags, getPositionStatistics} from '@/api/positions'
export default {
  name: "order-detail-module",
  data(){
    return{
      id: this.$route.params.sourceId,
      loading: false,
      showTalent: false,
      showOS: false,
      candidate: null,
      tracks: [],
      positionId: "",
      positionDetail: null,
      osViews: null,
      talentTags: null
    };
  },
  components: {
    orderProgress,positionItem,TabNearby,talentItem,popTalent,popOS
  },
  methods: {
    getDetail(){
      getCandidateDetail(this.id).then(res => {
        if (res && res.data) {
          this.candidate = res.data || null;
          this.tracks = this.candidate.candidateTracks || [];
          this.positionId = this.candidate.positionBaseEntity&&this.candidate.positionBaseEntity.positionId ? this.candidate.positionBaseEntity.positionId : "";
          if(this.positionId){
            this.getPositionDetail(this.positionId);
            this.getOsUser(this.positionId);
          }
          if(this.candidate&&this.candidate.talentId){
            this.getTalentTag(this.candidate.talentId);
          }
        }
      }).catch(err=>{});
    },
    getPositionDetail(id){
      getPositionDetail({positionId: id}).then(res => {
        if (res && res.data) {
          res.data.positionTags = [];
          res.data.statics = {};
          this.positionDetail = res.data;
          this.getPositionTags(id);
          this.getPositionStatistics(id);
        }
      }).catch(err=>{});
    },
    getPositionTags(id){
      getPositionTags({positionIds: id}).then(res=>{
        if (res && res.data && res.data[id]) {
          this.positionDetail.positionTags = res.data[id];
        }else{
          this.positionDetail.positionTags = [];
        }
      }).catch(err=>{});
    },
    getPositionStatistics(id){
      getPositionStatistics({positionIds: id}).then(res=>{
        if (res && res.data && res.data[id]) {
          this.positionDetail.statics = res.data[id];
        }else{
          this.positionDetail.statics = {};
        }
      }).catch(err=>{});
    },
    getOsUser(id){
      getOsUser({positionIds: id}).then(res => {
        if (res && res.data && res.data[id]) {
          this.osViews = res.data[id][0] ? res.data[id][0] : null;
        }else {
          this.osViews = null;
        }
      }).catch(err=>{});
    },
    getTalentTag(id){
      getTalentTag({talentIds: id}).then(res => {
        if (res && res.data && res.data[id]) {
          this.talentTags = res.data[id];
        }else {
          this.talentTags = null;
        }
      }).catch(err=>{});
    },
    goReport(){
      this.$router.push({ path:'/order/report/'+this.id});
    },
    init(){
      this.getDetail();
    }
  },
  created() {
    this.init();
  }
};
</script>
